const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.59,374.75,74.47,375l-6.66.11c-2.23,0-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,388.86l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.05H45.9v-.45l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16,388.86,89,389.14l-6.66.11c-2.23,0-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0L102,383.2c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.79,214.2l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0h-.45v-.45l0-11.18v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27V203c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.18-.44-.44c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,228.3l-13.13.28-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.45l0-11.18v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.15-5.65c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49L82,228.3l-.44-.44c2.18,0,4.35,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.66,259.61l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.89,61.14l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06H412v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27V50c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.87-.12-3.71-.14-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.66,75.25l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c0-1.87-.12-3.71-.13-5.54l.27.27c-4.41.06-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.36,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,61.14l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45L60.61,50v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28V50c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.06-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.44,379.77l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.71-.13-5.54l.27.28c-4.41.05-8.83.15-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,262.46l5.5-8.88-2.72-1.68a2.47,2.47,0,0,1-1.15-2.33,13.65,13.65,0,0,0,0-1.57,2.48,2.48,0,0,1,1.3-2.25l2.81-1.51L434.83,235,432,236.55a2.49,2.49,0,0,1-2.59-.17,13.23,13.23,0,0,0-1.33-.82,2.49,2.49,0,0,1-1.31-2.26l.1-3.19-10.44-.33-.09,3.21a2.49,2.49,0,0,1-1.46,2.16l-.69.35-.66.38a2.51,2.51,0,0,1-2.6,0l-2.73-1.7-5.51,8.88,2.72,1.69a2.45,2.45,0,0,1,1.15,2.33c0,.52-.06,1-.05,1.56a2.49,2.49,0,0,1-1.29,2.25l-2.82,1.51,4.94,9.21,2.81-1.52a2.51,2.51,0,0,1,2.6.17,13.82,13.82,0,0,0,1.32.82,2.47,2.47,0,0,1,1.31,2.25l-.1,3.2,10.44.33.1-3.21a2.47,2.47,0,0,1,1.45-2.15l.69-.35c.23-.12.45-.25.67-.38a2.5,2.5,0,0,1,2.61,0Zm-8.84-6.59a8.56,8.56,0,1,1,3.5-11.58A8.55,8.55,0,0,1,425.13,255.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.21,159.57l-3.65-6.34-1.94,1.12a1.75,1.75,0,0,1-1.83-.06c-.3-.2-.62-.38-.94-.55a1.74,1.74,0,0,1-1-1.54V150H69.57v2.24a1.74,1.74,0,0,1-1,1.54c-.32.17-.64.35-.94.55a1.75,1.75,0,0,1-1.83.06l-1.94-1.12-3.65,6.34,1.94,1.12A1.73,1.73,0,0,1,63,162.3c0,.18,0,.36,0,.54s0,.36,0,.54a1.75,1.75,0,0,1-.85,1.61l-1.95,1.13,3.65,6.33,2-1.12a1.73,1.73,0,0,1,1.82.06,10,10,0,0,0,.94.55,1.74,1.74,0,0,1,1,1.55v2.24h7.31v-2.24a1.75,1.75,0,0,1,1-1.55,9,9,0,0,0,1-.55,1.73,1.73,0,0,1,1.82-.06l2,1.12,3.65-6.33L84.27,165a1.72,1.72,0,0,1-.85-1.61c0-.18,0-.36,0-.54s0-.36,0-.54a1.72,1.72,0,0,1,.85-1.61Zm-7,3.27a6,6,0,1,1-6-6A6,6,0,0,1,79.22,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.14,163.32a28.5,28.5,0,1,0,28.5,28.5A28.5,28.5,0,0,0,161.14,163.32Zm0,41.8a13.31,13.31,0,1,1,13.31-13.3A13.29,13.29,0,0,1,161.14,205.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.62 164.5 155.67 164.5 156.27 156.75 166.02 156.75 166.62 164.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.77 168.2 138.02 175.94 132.96 170.03 139.85 163.14 145.77 168.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.63 185.55 133.63 196.51 125.88 195.9 125.88 186.16 133.63 185.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.32 206.41 145.07 214.16 139.16 219.21 132.27 212.32 137.32 206.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.68 218.54 165.64 218.54 165.03 226.3 155.29 226.3 154.68 218.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.53 214.85 183.28 207.1 188.34 213.02 181.45 219.91 175.53 214.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.67 197.5 187.67 186.54 195.43 187.14 195.43 196.89 187.67 197.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.98 176.64 176.23 168.89 182.15 163.84 189.04 170.73 183.98 176.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.9,40.27a28.49,28.49,0,1,0,28.49,28.49A28.48,28.48,0,0,0,378.9,40.27Zm0,41.79a13.31,13.31,0,1,1,13.31-13.3A13.3,13.3,0,0,1,378.9,82.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.38 41.45 373.42 41.45 374.02 33.69 383.77 33.69 384.38 41.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.52 45.14 355.77 52.89 350.72 46.97 357.61 40.08 363.52 45.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.38 62.49 351.38 73.45 343.63 72.85 343.63 63.1 351.38 62.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.08 83.35 362.82 91.1 356.91 96.15 350.02 89.26 355.08 83.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.43 95.49 383.39 95.49 382.79 103.24 373.04 103.24 372.43 95.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.29 91.8 401.04 84.05 406.09 89.96 399.2 96.85 393.29 91.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.43 74.44 405.43 63.48 413.18 64.09 413.18 73.83 405.43 74.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.73 53.58 393.99 45.84 399.9 40.78 406.79 47.67 401.73 53.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.48,
    width: 1,
    height: 101.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.62 134.24 108.91 140.19 47.05 140.19 44.35 134.24 70.69 116.01 85.28 116.01 111.62 134.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.11 98.45 85.28 116.01 70.69 116.01 68.86 98.45 87.11 98.45",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.61 134.24 108.91 140.19 47.05 140.19 44.35 134.24 111.61 134.24",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.52,
    width: 1,
    height: 57.57,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 89.98 180.94 95.93 119.08 95.93 116.39 89.98 142.72 71.76 157.31 71.76 183.65 89.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.14 54.19 157.31 71.76 142.72 71.76 140.89 54.19 159.14 54.19",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.65 89.99 180.94 95.94 119.08 95.94 116.38 89.99 183.65 89.99",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.11,364.65a58.89,58.89,0,0,1,1.93,10.9c-.1.18-.08.86,0,.67,0,.6.93.49.93-.1,0-.38,0-.77,0-1.14,2.13-2.65,5.22-4.32,7.72-6.62a14.47,14.47,0,0,0,4.23-6.73c2.07-7.14.13-14.71,2.62-21.84,2.15-6.14,6-11.48,9.26-17.05,3.45-5.88,6-12.07,6.24-19,.2-5.28-.43-12.31-4.45-16.27-4.26-4.2-9.54-1.05-12.81,2.69-9.46,10.86-13.83,24.58-15.6,38.61-1,7.77-2,15.58-1.76,23.42A63.35,63.35,0,0,0,406.11,364.65Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,378.4a133.55,133.55,0,0,1,.26-22s0,0,0-.08c-.12-5.94-.59-11.87-.36-17.82a107.14,107.14,0,0,1,2.62-19.12c0-.07.13-.05.12,0a123.56,123.56,0,0,0-2.07,18.7c-.12,3.35-.1,6.72.08,10.07.06,1.1.16,2.2.23,3.3h0a117.65,117.65,0,0,1,17.7-46.82c.12-.19.46,0,.34.21a122.35,122.35,0,0,0-14.4,34.72C417,331.14,423.9,324.2,429,316.1c0,0,.1,0,.08,0-4.58,9-12.15,16.13-17,25q-1.26,5.44-2,11a123.06,123.06,0,0,0-1.1,15.21,173,173,0,0,0,7.91-15.61c.06-.15.27-.05.22.1-1.92,5.69-4.52,11.82-8.15,16.67,0,3.61.09,7.21.3,10.81.57,9.6,2.21,19.08,3,28.65a.22.22,0,0,1-.44.05A219.81,219.81,0,0,1,408,378.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.2,304.33c0-.07.13,0,.11.05-1.76,4.85-2.75,9.76-4,14.74a.18.18,0,0,1-.36-.06A53.08,53.08,0,0,1,418.2,304.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.65,324.66a72.93,72.93,0,0,0,4,8.29c3.16,5.74,6.45,11,7.05,17.67a40.64,40.64,0,0,0,1.27,8.86,26.51,26.51,0,0,0,3.53,6.93c3.42,5,7.7,9.28,10.87,14.46a60.89,60.89,0,0,1,7.23,17.42c.08.34.61.25.53-.09a.1.1,0,0,1,0-.07.15.15,0,0,0,0-.07c.5-14.33-.64-28.76-5-42.48a147.18,147.18,0,0,0-6.94-17.67,41.76,41.76,0,0,0-9.37-13.48c-2.66-2.4-8.44-6.95-12.24-4.54C372.8,321.05,372.93,322.87,373.65,324.66Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.05,357.13a117.27,117.27,0,0,0,8.32,12c1.39,1.81,2.79,3.6,4.18,5.42.65.85,1.38,1.71,2,2.62-.37-1.5-.74-3-1.13-4.51-1.84-7.24-3.62-14.54-6.37-21.5a144.13,144.13,0,0,0-9.95-19.49c-.1-.17.17-.29.27-.13,3,5,6.1,9.95,8.64,15.2a79.85,79.85,0,0,1,3.67,9,139.66,139.66,0,0,0-4.88-19.26c0-.06.06-.1.08,0a65.89,65.89,0,0,1,5.07,20s0,0,0,0c.62,1.86,1.19,3.74,1.73,5.63,2.25,8,4.23,16.11,6.07,24.23a86.83,86.83,0,0,0-1.38-15.92.1.1,0,0,1,.19,0,50.54,50.54,0,0,1,1.38,16.79c.69,3.09,1.37,6.19,2,9.28,1.41,6.6,3.14,13.32,4,20a.14.14,0,0,1-.27,0c-1-3.61-1.57-7.36-2.37-11s-1.64-7.33-2.49-11q-1.87-8-3.88-15.95c-.89-1.95-2.6-3.68-3.89-5.31-1.41-1.79-2.82-3.58-4.19-5.4a80.9,80.9,0,0,1-6.89-10.67C387.88,357.11,388,357.06,388.05,357.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,351A74.88,74.88,0,0,1,395.58,364c0,.06-.06.12-.1.06-2.74-4.29-5.43-8.62-8.17-12.92C387.26,351,387.38,350.94,387.44,351Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.41,338.24c-1.86,3.2-4,7-3.18,10.88.5,2.43,2.28,4.4,2.6,6.88.72,5.47-4.73,9.08-8.68,11.67-9.83,6.45-23.32,12.2-25.11,25.38-.06.47-.87.35-.81-.11a.31.31,0,0,1,0-.08s-.05,0-.05-.08a50.53,50.53,0,0,1,.18-20.13c1.47-6.79,4.43-12.89,7.93-18.86,5.92-10.1,12.19-20.44,21.14-28.17,2.48-2.14,7.55-6,9.52-1.16S450.68,334.35,448.41,338.24Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.4,359.65c-6.52,7.06-16.88,11-22.5,18.92a79.27,79.27,0,0,1,17.3-32.48c.21-.24-.12-.59-.36-.36a63.92,63.92,0,0,0-14.13,20.47,91.4,91.4,0,0,1,6.08-15.56.17.17,0,0,0-.29-.17A59.63,59.63,0,0,0,418.94,368c-7.39,17.9-8.08,38.9-6.53,57.77,0,.27.44.28.43,0-.43-14.87-.19-30,3.38-44.52.07-.31.16-.61.23-.91,6.11-8.51,16.43-12.45,23.07-20.54C439.58,359.68,439.48,359.57,439.4,359.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,353.59c-3.43,3.14-6.8,6.35-10.23,9.49,0,0,0,.09.06.06a49.87,49.87,0,0,0,10.37-9.35A.14.14,0,0,0,440.92,353.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.46,340a108,108,0,0,1-10.24,14.09c-.05.06,0,.14.08.08a49.48,49.48,0,0,0,10.34-14.06C441.7,340,441.53,339.86,441.46,340Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.05 439.04 396.06 439.04 400.1 398.7 421.43 398.7 426.05 439.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.18 405.26 399.44 405.26 400.1 398.7 421.43 398.7 422.18 405.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 394.23,
    width: 28.1,
    height: 6.44,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.44 439.04 98.08 438.8 148.72 438.71 250 438.54 351.28 438.71 401.92 438.8 452.56 439.04 401.92 439.29 351.28 439.38 250 439.54 148.72 439.37 98.08 439.29 47.44 439.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.66,66.61H199.22a16.79,16.79,0,0,0-16.64,17V422.1A16.8,16.8,0,0,0,199.22,439H363.66a16.81,16.81,0,0,0,16.66-16.94V83.56A16.8,16.8,0,0,0,363.66,66.61Zm6.26,345c0,8.91-6.67,16.12-14.9,16.12H207.89c-8.25,0-14.92-7.21-14.92-16.12V96.39c0-18.15,6.67-19,14.92-19h29.47c1.71,0,3.11,2,3.11,4.36v1c0,5.65,3.09,5.67,6.9,5.67h68.15c3.83,0,6.9,0,6.9-5.67v-1c0-2.41,1.38-4.36,3.12-4.36H355c8.23,0,14.9,2.42,14.9,19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.74,81.36H272.15A1.15,1.15,0,0,1,271,80.22h0a1.15,1.15,0,0,1,1.15-1.15h18.59a1.15,1.15,0,0,1,1.15,1.15h0A1.15,1.15,0,0,1,290.74,81.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,96.39V411.63c0,8.91-6.67,16.12-14.9,16.12H207.9c-8.25,0-14.93-7.21-14.93-16.12V96.39c0-18.15,6.68-19,14.93-19h29.46c1.71,0,3.11,2,3.11,4.36v1c0,5.65,3.1,5.67,6.9,5.67h68.15c3.84,0,6.9,0,6.9-5.67v-1c0-2.41,1.38-4.36,3.12-4.36H355C363.25,77.35,369.92,79.77,369.92,96.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.7 106.78 205.55 103.83 208.7 100.89 209.19 101.41 206.59 103.83 209.19 106.26 208.7 106.78",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,102.81a1,1,0,1,1-1,1A1,1,0,0,1,349,102.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.66,102.81a1,1,0,1,1-1,1A1,1,0,0,1,352.66,102.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.32,102.81a1,1,0,1,1-1,1A1,1,0,0,1,356.32,102.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.28,84.43l-.29.29c-.05,0-.11.1-.16.16a3.87,3.87,0,0,0-5.49,0l-.15-.16-.28-.28h0l0,0c.12-.11.23-.22.36-.32a4.19,4.19,0,0,1,.83-.53,4.32,4.32,0,0,1,1.1-.37l.56-.07h.48c.12,0,.25,0,.37,0a4,4,0,0,1,1,.24,4.66,4.66,0,0,1,.68.32,4.12,4.12,0,0,1,.66.46c.1.08.2.18.3.27Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,85.77l-.45-.44a3.12,3.12,0,0,1,1.83-.92,3.21,3.21,0,0,1,2.76.91l-.45.45a2.62,2.62,0,0,0-3.69,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,86.22l-.45.45a1.34,1.34,0,0,0-1.89,0l-.44-.44A2,2,0,0,1,230.48,86.22Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,87.08a.41.41,0,0,1-.81,0,.41.41,0,1,1,.81,0Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.51,85.29a1.17,1.17,0,1,1,1.17,1.18A1.17,1.17,0,0,1,204.51,85.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,85.29a1.18,1.18,0,1,1,1.18,1.18A1.18,1.18,0,0,1,208.2,85.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.9,85.29a1.17,1.17,0,1,1,1.17,1.18A1.17,1.17,0,0,1,211.9,85.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,85.29a1.18,1.18,0,1,1,1.17,1.18A1.18,1.18,0,0,1,215.59,85.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.28,85.29a1.18,1.18,0,1,1,1.18,1.18A1.18,1.18,0,0,1,219.28,85.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,87.86h-9.56V83.42h9.56Zm-9.06-.5h8.56V83.92h-8.56Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.89,
    y: 84.18,
    width: 6.15,
    height: 2.92,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.65,
    y: 84.46,
    width: 0.85,
    height: 2.37,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.76,151.06a5.25,5.25,0,1,0,5.25-5.25A5.25,5.25,0,0,0,276.76,151.06Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.59,157.85a5,5,0,1,0,5-5A5,5,0,0,0,251.59,157.85Z",
    style: {
      fill: "#00796B",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,175.18a4.74,4.74,0,1,0,4.74-4.73A4.74,4.74,0,0,0,235.94,175.18Z",
    style: {
      fill: "#00796B",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.24,
    cy: 198.46,
    r: 4.47,
    style: {
      fill: "#00796B",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,220.43a4.22,4.22,0,1,0,4.22-4.22A4.22,4.22,0,0,0,236.05,220.43Z",
    style: {
      fill: "#00796B",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.71,238.4a4,4,0,1,0,4-4A4,4,0,0,0,251.71,238.4Z",
    style: {
      fill: "#00796B",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.47,245.91a3.7,3.7,0,1,0,3.7-3.7A3.7,3.7,0,0,0,278.47,245.91Z",
    style: {
      fill: "#00796B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,237.82a3.45,3.45,0,1,0,3.45-3.44A3.44,3.44,0,0,0,305.57,237.82Z",
    style: {
      fill: "#00796B",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.12,219a3.19,3.19,0,1,0,3.19-3.18A3.19,3.19,0,0,0,321.12,219Z",
    style: {
      fill: "#00796B",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,198a2.93,2.93,0,1,0,2.93-2.93A2.93,2.93,0,0,0,326.27,198Z",
    style: {
      fill: "#00796B",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.62,
    cy: 170.98,
    r: 2.67,
    style: {
      fill: "#00796B",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,155.8a2.42,2.42,0,1,0,2.42-2.42A2.41,2.41,0,0,0,301,155.8Z",
    style: {
      fill: "#00796B",
      opacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.09,209.66A11.69,11.69,0,1,0,269.34,198,11.69,11.69,0,0,0,281.09,209.66ZM270.76,198a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Zm10.33,11.63A11.69,11.69,0,1,0,269.34,198,11.69,11.69,0,0,0,281.09,209.66ZM270.76,198a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Zm10.33,11.63A11.69,11.69,0,1,0,269.34,198,11.69,11.69,0,0,0,281.09,209.66ZM270.76,198a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Zm10.4,24.57a24.63,24.63,0,1,0-24.77-24.48A24.63,24.63,0,0,0,281.16,222.6Zm-13.64-24.55a13.5,13.5,0,1,1,13.58,13.42A13.52,13.52,0,0,1,267.52,198.05Zm1.82,0A11.69,11.69,0,1,0,281,186.28,11.7,11.7,0,0,0,269.34,198Zm1.42,0a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Zm10.33,11.63A11.69,11.69,0,1,0,269.34,198,11.69,11.69,0,0,0,281.09,209.66ZM270.76,198a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Zm10.33,11.63A11.69,11.69,0,1,0,269.34,198,11.69,11.69,0,0,0,281.09,209.66ZM270.76,198a10.26,10.26,0,1,1,10.32,10.2A10.27,10.27,0,0,1,270.76,198Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.15 174.39 285.62 174.33 285.06 167.63 276.63 167.68 276.15 174.39",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.19 177.47 300.93 184.13 305.27 178.99 299.28 173.07 294.19 177.47",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.77 192.41 304.83 201.88 311.53 201.32 311.48 192.9 304.77 192.41",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.69 210.46 295.03 217.2 300.17 221.54 306.09 215.54 301.69 210.46",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.75 221.04 277.28 221.1 277.84 227.8 286.26 227.75 286.75 221.04",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.7 217.96 261.96 211.3 257.62 216.44 263.62 222.36 268.7 217.96",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.12 203.01 258.06 193.54 251.36 194.11 251.41 202.53 258.12 203.01",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.2 184.97 267.86 178.23 262.73 173.89 256.81 179.88 261.2 184.97",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.46,279.23h-118v-9.84h118Zm-117.53-.5H340v-8.84h-117Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.85,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.69,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.54,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.38,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.23,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.07,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.92,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.76,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.61,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.45,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.3,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 271.42,
    width: 4.23,
    height: 5.79,
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.77,272.9l-1.47,3.48a.31.31,0,0,1-.3.19l-.12,0a.34.34,0,0,1-.18-.43l1.27-3h-1.52a.33.33,0,0,1-.32-.33.32.32,0,0,1,.32-.32h2.08l.12.05,0,0,0,0,0,0s0,0,0,0,0,0,0,0l0,0v0l0,0v.13Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.47,274.51a2.46,2.46,0,0,1,.4-1.4,1.23,1.23,0,0,1,2.17,0,2.46,2.46,0,0,1,.4,1.4,2.49,2.49,0,0,1-.4,1.41,1.23,1.23,0,0,1-2.17,0A2.49,2.49,0,0,1,327.47,274.51Zm2.32,0a1.88,1.88,0,0,0-.29-1,.66.66,0,0,0-.54-.36.7.7,0,0,0-.56.36,2,2,0,0,0-.28,1,1.94,1.94,0,0,0,.28,1,.72.72,0,0,0,.56.37.68.68,0,0,0,.54-.37A1.86,1.86,0,0,0,329.79,274.51Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.58,273.47h0a1,1,0,0,1,1-1,1,1,0,0,1,1,1h0a1,1,0,0,1-1,1.05A1,1,0,0,1,331.58,273.47Zm1.41,0h0c0-.33-.19-.6-.45-.6s-.44.27-.44.59h0c0,.34.19.6.45.6S333,273.79,333,273.47Zm-.74,2.75,2.7-3.69a.21.21,0,0,1,.2-.1.23.23,0,0,1,.23.23.25.25,0,0,1-.05.15l-2.7,3.68a.23.23,0,0,1-.2.11.23.23,0,0,1-.23-.23A.25.25,0,0,1,332.25,276.22Zm1.81-.64h0a1,1,0,1,1,1.94,0v0a1,1,0,1,1-1.94,0Zm1.42,0h0c0-.33-.19-.6-.46-.6s-.44.27-.44.58v0c0,.33.19.6.46.6S335.48,275.89,335.48,275.58Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,290.08a.49.49,0,0,1,.49-.5.51.51,0,0,1,.51.5v5.31a.51.51,0,0,1-.51.5.49.49,0,0,1-.49-.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,295.39a.51.51,0,0,1-.49.5.49.49,0,0,1-.49-.5v-5.23h0a.47.47,0,0,1,.2-.41.48.48,0,0,1,.68.11l2.91,4v-3.71a.49.49,0,0,1,.48-.49.51.51,0,0,1,.5.49v5.23a.51.51,0,0,1-.5.5.53.53,0,0,1-.37-.18l0-.06-2.88-4Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,294.32a.46.46,0,0,1,.66-.06,2.94,2.94,0,0,0,1.72.69,1.91,1.91,0,0,0,1.12-.33.83.83,0,0,0,.39-.65.55.55,0,0,0-.08-.29,1,1,0,0,0-.27-.27A3.7,3.7,0,0,0,264,293h0a5,5,0,0,1-1.17-.35,1.92,1.92,0,0,1-.83-.71,1.3,1.3,0,0,1-.21-.73,1.69,1.69,0,0,1,.72-1.32,2.7,2.7,0,0,1,1.56-.48,3.59,3.59,0,0,1,2,.72.47.47,0,0,1,.13.64.46.46,0,0,1-.64.14,2.59,2.59,0,0,0-1.45-.58,1.71,1.71,0,0,0-1,.31.72.72,0,0,0-.34.57.41.41,0,0,0,.06.25.89.89,0,0,0,.24.23,3.18,3.18,0,0,0,1.13.4h0a5.31,5.31,0,0,1,1.24.38,2.12,2.12,0,0,1,.9.74,1.53,1.53,0,0,1,.21.77,1.73,1.73,0,0,1-.77,1.39,2.78,2.78,0,0,1-1.66.52,3.91,3.91,0,0,1-2.31-.9A.48.48,0,0,1,261.72,294.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,290.58h-1.43v4.81a.5.5,0,1,1-1,0v-4.81h-1.43a.49.49,0,0,1-.49-.5.49.49,0,0,1,.49-.5h3.85a.49.49,0,0,1,.49.5A.5.5,0,0,1,271.64,290.58Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,294.4h-2.19l-.44,1.17a.51.51,0,0,1-.47.32.47.47,0,0,1-.17,0,.52.52,0,0,1-.3-.65l2-5.3a.5.5,0,0,1,.48-.32.51.51,0,0,1,.48.32l2,5.3a.51.51,0,0,1-.29.65.47.47,0,0,1-.17,0,.48.48,0,0,1-.46-.32Zm-.37-1-.73-1.93-.73,1.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.58,295.39v-5.31a.49.49,0,0,1,.49-.5.5.5,0,0,1,.5.5v4.81H282a.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5h-2.94A.49.49,0,0,1,278.58,295.39Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,295.39v-5.31a.5.5,0,0,1,1,0v4.81h2.44a.51.51,0,0,1,.5.5.51.51,0,0,1-.5.5h-2.94A.5.5,0,0,1,283.64,295.39Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,290.08a.49.49,0,0,1,.49-.5.51.51,0,0,1,.51.5v5.31a.51.51,0,0,1-.51.5.49.49,0,0,1-.49-.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.49,295.39a.51.51,0,0,1-.49.5.49.49,0,0,1-.49-.5v-5.23h0a.47.47,0,0,1,.2-.41.48.48,0,0,1,.68.11l2.91,4v-3.71a.49.49,0,0,1,.48-.49.51.51,0,0,1,.5.49v5.23a.48.48,0,0,1-.86.32l-.05-.06-2.88-4Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,292.65a3.32,3.32,0,0,1,5.37-2.54.51.51,0,0,1,.1.73.53.53,0,0,1-.73.08,2.3,2.3,0,0,0-1.42-.49,2.22,2.22,0,0,0-1.62.66,2.14,2.14,0,0,0,0,3.11,2.22,2.22,0,0,0,1.62.66,2.51,2.51,0,0,0,1.24-.34v-1.24H301a.52.52,0,0,1-.52-.51.51.51,0,0,1,.52-.5h1.79a.5.5,0,0,1,.52.5v2a.66.66,0,0,1,0,.15.09.09,0,0,1,0,0h0a.4.4,0,0,1-.18.21,3.24,3.24,0,0,1-2,.71A3.28,3.28,0,0,1,297.71,292.65Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,294.61a.67.67,0,1,1,0,1.34.67.67,0,0,1,0-1.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.85,294.61a.67.67,0,1,1,0,1.34.67.67,0,0,1,0-1.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,294.61a.67.67,0,1,1,0,1.34.67.67,0,0,1,0-1.34Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.12,439.37l144.36.62c35.09-27.55,38.71-68.37,13.68-93.11-15.15-15-34.38-11.95-52.7-14.33h-.06a54.11,54.11,0,0,1-18.58-5.45c-18.86-9.95-29.49-33.43-45.36-53.17-2-2.48-4-4.88-6.21-7.2-13-13.94-39-14.39-52.61,5.2C32.12,321.69,47.93,395.77,84.12,439.37Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,439.37l144.36.62c35.09-27.55,38.71-68.37,13.68-93.11-15.15-15-34.38-11.95-52.7-14.33h-.06a54.11,54.11,0,0,1-18.58-5.45c-18.86-9.95-29.49-33.43-45.36-53.17-2-2.48-4-4.88-6.21-7.2-13-13.94-39-14.39-52.61,5.2C32.12,321.69,47.93,395.77,84.12,439.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,325.49c3.78,59.22,72.18,81.33,114.9,63.59,37.14-15.43,25-50.64-6.36-56.53h-.06a54.11,54.11,0,0,1-18.58-5.45c-18.86-9.95-29.49-33.43-45.36-53.17C101.82,261.64,78.15,282.12,80.92,325.49Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.08,448.7c-2.23-.82-52.53-41-53.48-43.77-.37-1,5.06-8.71,11.88-17.79,1.47-2,3-4,4.58-6,10.16-13.25,21.26-27.07,21.26-27.07l33.73,26.8-22.19,26.33L205,413s12.38,24,13.1,27.13S216.31,449.52,214.08,448.7Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.62,449.31c-2.31-.8-54.94-41.35-56-44.17-.4-1.06,5.06-9.08,11.94-18.57l.21-.29,34.25,25.78-.46.57s13.2,24.53,14,27.75S217.93,450.11,215.62,449.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,446.81c-8.7-7.06-44.47-34.69-53.61-41-.07-.05-.11,0,0,.06,8.47,7.18,44.46,34.52,53.54,41.08C216.68,447.09,216.78,447,216.6,446.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,414.93c-3-3.34-7.67-6.1-12.25-5.67-.18,0-.15.27,0,.32A61.78,61.78,0,0,1,208,415.36.28.28,0,0,0,208.37,414.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,418.39c-3-3.34-7.67-6.1-12.25-5.67-.18,0-.15.27,0,.32a61.78,61.78,0,0,1,11.91,5.78A.28.28,0,0,0,209.72,418.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.07,421.85c-3-3.34-7.67-6.1-12.25-5.67-.18,0-.15.27,0,.32a61.78,61.78,0,0,1,11.91,5.78A.28.28,0,0,0,211.07,421.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.88,448c.66,1.09-2,4.1-2.85,3.82S157,407.12,156.16,406.15s2.25-4.19,3.52-3.5S217.88,448,217.88,448Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,398.87c-2.34-4.85-9.88-1.22-7.53,3.64S178.31,403.72,176,398.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.12,329.33c-2.31,17.53-45.5,68.12-50.49,73.92l-1.14,1.32-35.72-27.46.41-.53,31.46-41.19s-52,30.36-78,16.58c-11.69-6.19-20.35-17.18-20.35-17.18l34-18.12s9.4,3,15.41,2.16c20.7-3,67.11-20.64,78.12-20.2C253.94,299.21,268.24,313.25,266.12,329.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,320.08a42.24,42.24,0,0,0-3.25,4.16c-1.11,1.46-2.24,2.9-3.35,4.36l0,0,.59-1.28c.7-1.45,1.26-2.95,2.09-4.33,0-.09-.08-.17-.13-.08-.85,1.37-1.84,2.68-2.57,4.13-.34.69-.67,1.38-1,2.08-.16.38-.33.77-.48,1.16a5.37,5.37,0,0,0-.21.56c-.5.68-1,1.36-1.46,2.05-1.06,1.53-2,3.15-3.07,4.68-.06.08.07.15.13.08,1.09-1.43,2.3-2.77,3.41-4.19s2.18-2.93,3.24-4.43,2-2.94,3.05-4.4a43.54,43.54,0,0,0,3.1-4.52S222,320,221.94,320.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,370.88c2,1.81,4.08,3.5,6.15,5.19s4.16,3.39,6.26,5.07c4.19,3.36,8.37,6.74,12.61,10,2.33,1.82,4.68,3.61,7.1,5.29.11.08.23-.09.13-.18-4-3.61-8.21-6.92-12.4-10.27s-8.41-6.7-12.66-10c-2.32-1.81-4.63-3.66-7.07-5.32C186,370.64,185.84,370.8,185.92,370.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,282.47c7.62,18.06,31.41,36.11,39.13,36.59,9,.56,32-10.41,40.63-23.16,2.05-3-17.39-16.61-20.55-14.32-6.49,4.72-18.78,11.21-19.84,11.32-2.12.22-17-7.84-28.53-15.44C126.72,268,127.15,275.27,130.19,282.47Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,299.29s8-8.74,8.66-16.78c.45-5.56-.52-20.25-14.13-29.84-3.23-2.28-9.45-3.23-5.52,2.4,2.78,4,5.76,5.69,7,8.32,0,0-8.05-.28-10.2,3.05a71.21,71.21,0,0,0-5,9.08,14.54,14.54,0,0,0,1.61,1.09s-1.71,3.3-.31,8.77Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17,247.39l-8.34,29.29c-.34.86.07,1.58.92,1.6l15.23.47a2.5,2.5,0,0,0,2.17-1.51L204.49,248c.34-.86-.07-1.58-.92-1.6l-15.24-.47A2.47,2.47,0,0,0,186.17,247.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,247.43l-8.34,29.29c-.35.86.07,1.58.92,1.6l15.23.47a2.47,2.47,0,0,0,2.16-1.51L206.3,248c.34-.86-.07-1.58-.92-1.6l-15.24-.47A2.46,2.46,0,0,0,188,247.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.11,248.9a1.29,1.29,0,1,1-1.22-1.36A1.28,1.28,0,0,1,192.11,248.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,274.65c-1.74-2.35-5.51-7.27-10-10.22-5-3.28-15.46-8.26-17.84-4.56-1.75,2.71,2.08,5,2.08,5s-4.76-1.14-5.8,1.66c-.95,2.55,2.12,4.11,2.12,4.11s-3-.2-3.46,2.43c-.53,3.17,5.87,3.06,8.1,6.73C190.65,280.59,214.94,274.65,214.94,274.65Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,270.27a23.67,23.67,0,0,0-13.06-5.49c-.12,0-.19.08-.08.11a59,59,0,0,1,13.11,5.42S202.38,270.29,202.36,270.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,275.2c-1.89-1.5-7.89-4.59-13.36-4.7-.12,0-.19.09-.07.11a62.62,62.62,0,0,1,13.4,4.64S198.93,275.22,198.9,275.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08,278.5c.07,1.77.14,3.48.34,5.19.1.85.26,1.68.44,2.52a23.64,23.64,0,0,0,.76,2.49,9.43,9.43,0,0,1-2-4.92,15.88,15.88,0,0,1-.06-2.67A11,11,0,0,1,189.08,278.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.37,301.1,154,285s-11.43-9.26-19.62-12.66-9.19,1.85-5.42,9.63S140.37,301.1,140.37,301.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,276.85l-.93-.58a9.51,9.51,0,0,0,1.15,1.83A8.59,8.59,0,0,0,142.62,276.85Zm9.9,7h0a12.87,12.87,0,0,0-2.29.69,11.26,11.26,0,0,0-2.71,1.54,11.22,11.22,0,0,0,3-.79,11.74,11.74,0,0,0,2.29-1.22Zm-17.92,2.42a11.09,11.09,0,0,0-.82,3,11.26,11.26,0,0,0,1.57-2.69,11.09,11.09,0,0,0,.82-3A11.26,11.26,0,0,0,134.6,286.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,289.28l-10,11.82s-7.66-11.34-11.43-19.11c-2.84-5.85-3-10.27.61-10.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9,282.75a133.71,133.71,0,0,0-11.8,13.46s.09.12.11.1c3.43-3.48,9.74-10.91,11.84-13.42C150.09,282.85,149.94,282.71,149.9,282.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.93,342.7c2,.64,58.79-15.79,58.79-15.79L148,307.19s3.31-6.34,1.77-12.44c-2.05-8.15-17.13-21.55-18.32-22.33-4.76-3.16-9.22-3.1-13.16-1C101.88,280.14,95.93,342.7,95.93,342.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,297.53c-.45-.25-.92-.47-1.39-.68a10.75,10.75,0,0,0-3-.83,11.26,11.26,0,0,0,2.69,1.57,14.48,14.48,0,0,0,1.72.58C150.19,298,150.19,297.74,150.17,297.53Zm-26.88-2.87a10.75,10.75,0,0,0-3-.83A11.26,11.26,0,0,0,123,295.4a11.09,11.09,0,0,0,3,.82A11.22,11.22,0,0,0,123.29,294.66Zm13.13,35.63a10.75,10.75,0,0,0-3-.83,11.07,11.07,0,0,0,2.69,1.57,12.84,12.84,0,0,0,2,.64h0l.57-.16A11.82,11.82,0,0,0,136.42,330.29ZM107.53,329a11,11,0,0,0-3-.83,10.7,10.7,0,0,0,2.68,1.57,10.85,10.85,0,0,0,3,.83A11.07,11.07,0,0,0,107.53,329ZM122.8,317.4a10.69,10.69,0,0,0-.83,3,12,12,0,0,0,2.4-5.68A10.93,10.93,0,0,0,122.8,317.4Zm11.8-31.11a11.09,11.09,0,0,0-.82,3,11.26,11.26,0,0,0,1.57-2.69,11.09,11.09,0,0,0,.82-3A11.26,11.26,0,0,0,134.6,286.29Zm10.32,29.37a11.26,11.26,0,0,0-2.71,1.54,11.22,11.22,0,0,0,3-.79,10.93,10.93,0,0,0,2.71-1.54A11.22,11.22,0,0,0,144.92,315.66ZM107.75,311a11.26,11.26,0,0,0-2.71,1.54,11.22,11.22,0,0,0,3-.79,10.93,10.93,0,0,0,2.71-1.54A11.22,11.22,0,0,0,107.75,311Zm9.92-32.85a10.89,10.89,0,0,0-2.71,1.53,11.22,11.22,0,0,0,3-.79,10.89,10.89,0,0,0,2.71-1.53A10.52,10.52,0,0,0,117.67,278.13Zm3.14,57.42a9.27,9.27,0,0,0,.14.92l.43-.12A8.39,8.39,0,0,0,120.81,335.55Zm-12.54-40.68a11.16,11.16,0,0,0-1.53-2.7,10.52,10.52,0,0,0,.79,3,10.83,10.83,0,0,0,1.53,2.7A10.52,10.52,0,0,0,108.27,294.87Zm27.08,10.26a10.87,10.87,0,0,0-1.54-2.7,11.05,11.05,0,0,0,.79,3,10.75,10.75,0,0,0,1.54,2.71A11.22,11.22,0,0,0,135.35,305.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,307.42a51.08,51.08,0,0,1,7.4-.82c1.23,0,2.46,0,3.69.06.62,0,1.23,0,1.85,0a7.64,7.64,0,0,0,1.91-.17,0,0,0,0,1,0,.09,13.54,13.54,0,0,1-1.77.46,12.93,12.93,0,0,1-1.76.15c-1.25,0-2.5,0-3.75,0-2.53.06-5.06.11-7.57.35C130.92,307.64,130.9,307.44,131,307.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,311.18a55.92,55.92,0,0,1,5.82-1.94c1-.26,2-.47,3-.65l1.45-.23c.54-.08,1.08-.09,1.61-.17.06,0,.08.07,0,.08-.49.1-1,.28-1.47.4l-1.49.38-3,.75c-2,.49-4,1-5.93,1.55C125.65,311.38,125.62,311.22,125.72,311.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,272.21c.3,1,5.63,7.34,10.3,6.81,1.52-.17.94-8.51.94-8.51l.1-.63,1.36-8.75-12.08-6.61S121.54,271.78,121.67,272.21Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,261.12,133,269.88a17.76,17.76,0,0,1-11-9.46c.11-3,.22-5.48.23-5.85v0l1.53.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.62,246.34a1.38,1.38,0,0,1-1,2.48,1.47,1.47,0,0,1,0,.59,1.52,1.52,0,0,1-1.69,1.16,1.16,1.16,0,0,1,0,.49,1.38,1.38,0,0,1-1.66,1,1.34,1.34,0,0,1-.77-.49,1.38,1.38,0,0,1-1.63.92,1.48,1.48,0,0,1-.52-.25l0,.12a1.37,1.37,0,0,1-1.66,1,1.34,1.34,0,0,1-1-.81,1.37,1.37,0,0,1-1.56.76,1.4,1.4,0,0,1-1-1,1.55,1.55,0,0,1-1,.11,1.49,1.49,0,0,1-.95-.7,1.51,1.51,0,0,1-2.32-1.2,1.7,1.7,0,0,1-.55,0,1.38,1.38,0,0,1-1.06-1.48,1.51,1.51,0,0,1-1.81-1.82,1.18,1.18,0,0,1,.19-.46l-.24,0a1.4,1.4,0,0,1-1-1.66,1.42,1.42,0,0,1,.36-.66,1.52,1.52,0,0,1-1-1.78,1.47,1.47,0,0,1,.41-.73,1.52,1.52,0,0,1-.65-1.62,1.48,1.48,0,0,1,.85-1,1.37,1.37,0,0,1-.21-1.1,1.34,1.34,0,0,1,.68-.9,1.49,1.49,0,0,1-.32-1.31,1.52,1.52,0,0,1,1.37-1.17,1.23,1.23,0,0,1,0-.66,1.38,1.38,0,0,1,1.47-1.07,1.3,1.3,0,0,1,0-.65,1.51,1.51,0,0,1,1.82-1.14,1.61,1.61,0,0,1,.33.12,2,2,0,0,1,0-.24,1.52,1.52,0,0,1,1.82-1.14,1.4,1.4,0,0,1,.36.13,1.27,1.27,0,0,1,0-.43,1.53,1.53,0,0,1,2.8-.43,1.52,1.52,0,0,1,1.43-.43,1.55,1.55,0,0,1,.93.65,1.39,1.39,0,0,1,2.53.21,1.39,1.39,0,0,1,2.21,1,1.5,1.5,0,0,1,1.21-.24,1.54,1.54,0,0,1,1.18,1.52,1.41,1.41,0,0,1,.5,0,1.38,1.38,0,0,1,1,1.66,1.46,1.46,0,0,1-.2.46h.09a1.52,1.52,0,0,1,1.14,1.83,1.35,1.35,0,0,1-.16.41,1.2,1.2,0,0,1,.37,0,1.38,1.38,0,0,1,1,1.65,1.43,1.43,0,0,1-.62.87,1.37,1.37,0,0,1,.42,1.34,1.39,1.39,0,0,1-.6.85,1.52,1.52,0,0,1-.59,2.83,1.36,1.36,0,0,1,.38,1.28A1.39,1.39,0,0,1,116.62,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.06,231.32a1.38,1.38,0,0,1-1,2.48,1.47,1.47,0,0,1,0,.59,1.52,1.52,0,0,1-1.69,1.16,1.16,1.16,0,0,1,0,.49,1.38,1.38,0,0,1-1.66,1,1.31,1.31,0,0,1-.77-.49,1.38,1.38,0,0,1-1.63.92,1.53,1.53,0,0,1-.53-.25.5.5,0,0,1,0,.12,1.37,1.37,0,0,1-1.66,1,1.34,1.34,0,0,1-1-.81,1.38,1.38,0,0,1-1.56.76,1.4,1.4,0,0,1-1-1,1.55,1.55,0,0,1-1,.11,1.51,1.51,0,0,1-1-.7,1.5,1.5,0,0,1-1.14.2,1.53,1.53,0,0,1-1.18-1.4,1.65,1.65,0,0,1-.54,0,1.38,1.38,0,0,1-1.06-1.48,1.52,1.52,0,0,1-1.82-1.82,1.37,1.37,0,0,1,.2-.46l-.24,0a1.39,1.39,0,0,1-1-1.66,1.42,1.42,0,0,1,.36-.66,1.52,1.52,0,0,1-1-1.78,1.53,1.53,0,0,1,.4-.73,1.53,1.53,0,0,1-.64-1.62,1.48,1.48,0,0,1,.85-1,1.38,1.38,0,0,1,.47-2,1.49,1.49,0,0,1-.32-1.31,1.52,1.52,0,0,1,1.37-1.17,1.34,1.34,0,0,1,0-.66,1.39,1.39,0,0,1,1.48-1.07,1.43,1.43,0,0,1,0-.65,1.52,1.52,0,0,1,1.83-1.14,1.85,1.85,0,0,1,.33.12,1,1,0,0,1,0-.24,1.51,1.51,0,0,1,1.82-1.14,1.21,1.21,0,0,1,.35.13,1.28,1.28,0,0,1,0-.43,1.53,1.53,0,0,1,2.8-.43,1.52,1.52,0,0,1,1.43-.43,1.55,1.55,0,0,1,.93.65,1.36,1.36,0,0,1,1.53-.69,1.38,1.38,0,0,1,1,.9,1.38,1.38,0,0,1,2.2,1,1.51,1.51,0,0,1,1.21-.24,1.54,1.54,0,0,1,1.19,1.52,1.41,1.41,0,0,1,.5,0,1.38,1.38,0,0,1,1,1.66,1.25,1.25,0,0,1-.19.46h.09A1.52,1.52,0,0,1,140,221a1.67,1.67,0,0,1-.16.41,1.11,1.11,0,0,1,.36,0,1.37,1.37,0,0,1,1,1.65,1.41,1.41,0,0,1-.63.87,1.36,1.36,0,0,1,.43,1.34,1.39,1.39,0,0,1-.6.85,1.52,1.52,0,0,1-.59,2.83,1.36,1.36,0,0,1,.38,1.28A1.4,1.4,0,0,1,139.06,231.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,245.37c4.72,14.81-3.62,19.32-6.81,20.33-2.91.92-12.9,3.69-19.13-10.56s-.84-21.13,5.69-23.59S139.64,230.55,144.36,245.37Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,243.78c-.36,0-.71,0-1.07,0a1.73,1.73,0,0,1-1.1-.17.56.56,0,0,1-.16-.66,1.36,1.36,0,0,1,1.24-.63,2.05,2.05,0,0,1,1.4.39A.6.6,0,0,1,141.69,243.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,247.48a8.6,8.6,0,0,0,1-.46,1.76,1.76,0,0,0,.9-.66.57.57,0,0,0-.16-.66,1.38,1.38,0,0,0-1.39,0,2,2,0,0,0-1.06,1A.59.59,0,0,0,131.63,247.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32,249.23s-.06.07,0,.11c.31,1,.49,2.22-.35,2.81,0,0,0,.07,0,.06C135,251.75,134.78,250.14,134.32,249.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,248.4c-1.67.32-.92,3.65.64,3.36S134.53,248.14,133.12,248.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.51,248.73c-.25.25-.46.65-.8.76s-.79-.14-1.13-.42c0,0-.05,0-.05.05.14.64.53,1.24,1.24,1.18s1-.72,1-1.4C132.75,248.78,132.61,248.62,132.51,248.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.36,247.58s.09,0,.1.08c.19,1,.59,2.2,1.6,2.34a0,0,0,0,1,0,.06C140.88,250.15,140.37,248.6,140.36,247.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,246.3c1.64-.49,2.5,2.82,1,3.27S139.67,246.71,141,246.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.79,246.34c.31.11.65.36,1,.3s.54-.5.68-.9c0-.05.05,0,.06,0,.18.63.15,1.34-.43,1.62s-1.07-.18-1.39-.77C141.62,246.5,141.67,246.29,141.79,246.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,258c.29.21.59.51,1,.48a2.67,2.67,0,0,0,1.08-.43,0,0,0,0,1,.06.05,1.44,1.44,0,0,1-1.25.77,1.14,1.14,0,0,1-1-.8A.06.06,0,0,1,136.05,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,253s.54,1.5.69,2.23c0,.07-.15.14-.4.2,0,0,0,0,0,0a3.54,3.54,0,0,1-3.64-.59.08.08,0,0,1,.09-.12,5.38,5.38,0,0,0,3.36.24c0-.21-1-2.54-.89-2.58a6.75,6.75,0,0,1,1.73,0c-1-3.16-2.56-6.13-3.54-9.3,0-.11.13-.18.18-.09a53.8,53.8,0,0,1,4.24,9.86C141.55,253.33,139.93,253.1,139.61,253Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,255.19a4.39,4.39,0,0,1-1.26,1.81,2,2,0,0,1-1.11.42c-.88.05-1.14-.7-1.19-1.39a4.27,4.27,0,0,1,.06-1.1A5.64,5.64,0,0,0,139.81,255.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.55,257a2,2,0,0,1-1.11.42c-.88.05-1.14-.7-1.19-1.39A2,2,0,0,1,138.55,257Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,233.72a7,7,0,0,1,.7,4.05c-.87,3.82-5.24,3.84-6.35,5.53s0,4.12-.91,5.67c-1.27,2.15-2.69,1.13-2.7,2.39s0,5.23-1.36,6.06-14.06-22.88,6-26.55c0,0,2.53-1.89,7.19-.54,6.64,1.92,9.41,9.51,9.41,9.51a5.17,5.17,0,0,1-2.08-.43c-1.15-.63-1.76-1.16-2.59-1.55-1.3-.61-1.84.15-3.18-.43C132.29,236.54,130.19,233.72,130.19,233.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,232.92a13.63,13.63,0,0,1,1.26,2.91,5.7,5.7,0,0,1,.24,3,4.17,4.17,0,0,1-1.89,2.28c-.86.56-1.88.9-2.81,1.53a3.13,3.13,0,0,0-1.11,1.3,4.21,4.21,0,0,0-.24,1.66,5.57,5.57,0,0,1-.49,3,3.52,3.52,0,0,1-2.41,1.72,7.41,7.41,0,0,0-3.05.85c.93-.59,2-.46,3.09-.61a3.8,3.8,0,0,0,2.7-1.76,5.72,5.72,0,0,0,.62-3.2,3.69,3.69,0,0,1,.22-1.47,2.75,2.75,0,0,1,1-1.08c.83-.59,1.85-.95,2.77-1.55a5.63,5.63,0,0,0,1.25-1.09,3.54,3.54,0,0,0,.77-1.49,6,6,0,0,0-.39-3.22A13.41,13.41,0,0,0,129.82,232.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,233.74a10.88,10.88,0,0,0,1.58,2.52,5.25,5.25,0,0,0,2.48,1.75,8.36,8.36,0,0,0,1.5.22,2.32,2.32,0,0,1,1.23.48,7.24,7.24,0,0,0,1.13,1,3.37,3.37,0,0,0,1.43.45,3.74,3.74,0,0,1-1.29-.65,7.84,7.84,0,0,1-1-1.06,2.6,2.6,0,0,0-1.43-.67,7.53,7.53,0,0,1-1.42-.23,5.54,5.54,0,0,1-2.33-1.54A21.54,21.54,0,0,1,130.4,233.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,255.53s-4.38-4-6.26-2.32,2.16,8,4.89,8.33a2.63,2.63,0,0,0,3.13-2.15Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08,255a0,0,0,0,0,0,.07c1.93.32,3.23,1.75,4.27,3.3a1.46,1.46,0,0,0-2.21.1s0,.1.07.08a1.61,1.61,0,0,1,1.86.16,7.83,7.83,0,0,1,1.15,1.22c.12.13.38,0,.28-.18l0,0C121,257.42,118.55,254.66,116.08,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,285.13c3.89,23.81,14.83,41.2,19.37,41.95,12.21,2,32.86-18,39-22.64,2.49-1.9-17.82-18.9-20.22-16.57-5.66,5.48-13.16,12.82-13.57,12.82-.86,0-3.77-5.92-14.4-19.88C115.9,269.12,113,275.4,114.6,285.13Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,264.92c1.68,2.57-5,6.2-5,6.2a5.69,5.69,0,0,1,3.62,1.33c1.72,1.59,0,5,0,5a7,7,0,0,1,3.59,2c1.49,1.68.22,5.35.22,5.35a6.34,6.34,0,0,1,2,3.76c.79,6.51-13.42,15.81-18,17.6l-18.63-16.82s6.91-15.44,12.54-19.43C167.74,267.69,181.72,261,184.3,264.92Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,271.08a51.16,51.16,0,0,0-11.27,5.5.07.07,0,1,0,.07.12c3.51-2.16,7.69-3.43,11.28-5.44A.1.1,0,0,0,179.19,271.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,277.23a10.69,10.69,0,0,0-2.47,1.42c-.84.56-1.67,1.13-2.49,1.72q-2.47,1.77-4.85,3.66c-.07.06,0,.18.08.13q2.46-1.77,5-3.43c.84-.55,1.69-1.09,2.55-1.63a13.12,13.12,0,0,0,2.34-1.64A.14.14,0,0,0,182.62,277.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.63,284.85a7.53,7.53,0,0,0-2.16,1.39l-2.23,1.65c-1.48,1.09-3,2.18-4.5,3.21a.08.08,0,0,0,.08.13c1.55-1.05,3.12-2.07,4.67-3.13l2.27-1.58a7.11,7.11,0,0,0,1.93-1.6S186.67,284.83,186.63,284.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,286.44a5.1,5.1,0,0,1,.87,3.43,7.14,7.14,0,0,1-1.35,3.36,30.82,30.82,0,0,1-4.76,5.37,46.38,46.38,0,0,1-5.67,4.39,38.59,38.59,0,0,1-6.31,3.37l0,0c-1.4,1.15-10.6,9.1-12.07,9.7,1.3-1.26,10.45-8.81,11.78-10l0,0h0a47.62,47.62,0,0,0,6.09-3.58,55.79,55.79,0,0,0,5.57-4.34,38.4,38.4,0,0,0,4.84-5.12,7.14,7.14,0,0,0,1.45-3.1A5.16,5.16,0,0,0,188,286.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72,305.17l18.37-10.31s-7.47-12.67-14-18.72-9.25-1.47-8.43,7.13S117.72,305.17,117.72,305.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,278.13a10.89,10.89,0,0,0-2.71,1.53,11.22,11.22,0,0,0,3-.79,10.89,10.89,0,0,0,2.71-1.53A10.52,10.52,0,0,0,117.67,278.13Zm5.62,16.53a10.75,10.75,0,0,0-3-.83A11.26,11.26,0,0,0,123,295.4a11.09,11.09,0,0,0,3,.82A11.22,11.22,0,0,0,123.29,294.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,291.31a134.44,134.44,0,0,0-15.76,8.49s0,.14.07.13c4.43-2.06,12.94-6.82,15.78-8.43C133.14,291.47,133,291.28,133,291.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,304.17c-.56.39-1.14.76-1.71,1.13l-.17.12-.06-.22q-1.12-4.15-2-8.37c-.28-1.4-.56-2.81-.78-4.22s-.46-2.83-.62-4.26c.42,1.38.8,2.77,1.14,4.16s.68,2.78,1,4.18q.92,4.19,1.56,8.44l-.23-.1C118.27,304.74,118.88,304.44,119.51,304.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.22,293.69a11.2,11.2,0,0,1-.94-1.51,10.66,10.66,0,0,1-.72-1.62,12.36,12.36,0,0,1,1.66,3.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,295.37c.19-.22.4-.42.6-.64l0,.21c-1.29-1.94-2.54-3.89-3.81-5.83l-3.79-5.85a35.45,35.45,0,0,1,4.41,5.44,45.69,45.69,0,0,1,3.46,6.09l.07.14-.11.06C135.92,295.12,135.67,295.26,135.4,295.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,287.52a11.19,11.19,0,0,1-.77-1.6,12.41,12.41,0,0,1-.53-1.7,11.19,11.19,0,0,1,.77,1.6A12.41,12.41,0,0,1,131.74,287.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,403.13c-.82,2.23-41.19,52.4-43.94,53.35-1,.36-8.69-5.1-17.75-12-2-1.48-4-3-6-4.59-13.21-10.21-27-21.35-27-21.35l26.91-33.65L303,407.22l5.76,4.89s24.05-12.3,27.18-13S345.32,400.91,344.5,403.13Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,402.23c-.9,2.28-43.72,53.07-46.58,54-1.08.36-8.85-5.45-18-12.74l-.28-.23,27.26-33.08.54.48s25.09-12.11,28.34-12.76S345.23,400,344.33,402.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,401.14c-7.43,8.39-36.6,42.91-43.3,51.76-.06.08,0,.11.05.05,7.55-8.15,36.44-42.91,43.39-51.69C342.16,401.08,342,401,341.87,401.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.66,408c-3.47,2.84-6.42,7.4-6.19,12,0,.18.26.16.32,0a61.8,61.8,0,0,1,6.29-11.65A.28.28,0,0,0,309.66,408Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,406.77c-3.47,2.83-6.43,7.39-6.2,12,0,.18.27.16.32,0a62.38,62.38,0,0,1,6.29-11.65A.28.28,0,0,0,313.18,406.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.7,405.57c-3.47,2.84-6.43,7.4-6.2,12,0,.18.26.17.32,0a61.8,61.8,0,0,1,6.29-11.65A.28.28,0,0,0,316.7,405.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.16,399.92c1.12-.62,4,2.15,3.7,3s-47.25,56-48.25,56.8-4.09-2.43-3.34-3.67S343.16,399.92,343.16,399.92Z",
    style: {
      fill: "#00796B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.2,439.64c-4.95,2.13-1.65,9.82,3.31,7.69S297.15,437.51,292.2,439.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.57,402.14l-28,37.78-94.48-65.56L170,368s-2.58,1.74-6.47,3.89c-5.39,3-13.3,6.75-20.29,7.78-11.73,1.74-31.32,1.55-41.2-11.67-8.33-11.13-3.81-25.65-3.81-25.65l12.88-5.53s30.48-25.4,50.22-26.16c8.39-.33,20.6,6,31.91,12.66S301.57,402.14,301.57,402.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,368s-2.58,1.74-6.47,3.89c-6.86-8.22-21.4-23.15-21.84-23.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,328.35c-1.82,1.26-3.58,2.61-5.38,3.91s-3.59,2.47-5.27,3.87-3.33,2.93-4.94,4.46c-.78.74-1.55,1.48-2.3,2.24a21.47,21.47,0,0,0-2.2,2.38.1.1,0,0,0,.14.13,25.73,25.73,0,0,0,2.44-2l2.55-2.17c1.63-1.39,3.3-2.75,4.94-4.15s3.13-2.9,4.73-4.31,3.54-2.9,5.33-4.32C122.33,328.38,122.3,328.32,122.26,328.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,398.29c-1.7,2.07-3.25,4.28-4.81,6.45s-3.13,4.37-4.68,6.56c-3.1,4.39-6.22,8.77-9.26,13.2-1.67,2.44-3.31,4.89-4.85,7.41-.06.11.11.22.2.12,3.36-4.18,6.4-8.61,9.49-13s6.17-8.8,9.2-13.24c1.66-2.43,3.37-4.86,4.88-7.38A.11.11,0,0,0,292,398.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,401.17c-4.7-3.7-9.57-7.2-14.45-10.67s-9.69-6.93-14.61-10.28q-2.13-1.44-4.27-2.85c-1.42-.95-2.9-1.82-4.29-2.8-.08-.06-.15.08-.07.13,1.28.92,2.48,1.95,3.74,2.9s2.39,1.83,3.6,2.72c2.36,1.75,4.74,3.46,7.12,5.19q7.25,5.24,14.61,10.3c2.79,1.91,5.56,3.83,8.41,5.65C217.41,401.57,217.62,401.3,217.45,401.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,362.19c-4.34-3.6-9-6.83-13.55-10.16s-9.19-6.77-13.81-10.11L206.54,332c-4.44-3.21-8.87-6.48-13.56-9.32-2.57-1.56-5.21-3-7.92-4.31a52.78,52.78,0,0,0-8.18-3.34.08.08,0,0,0-.06.14c2.32,1.3,4.75,2.38,7.09,3.63s4.6,2.53,6.84,3.89c4.67,2.83,9.07,6,13.49,9.22,9.19,6.61,18.35,13.24,27.6,19.75,5.18,3.65,10.25,7.5,15.62,10.85C247.63,362.58,247.83,362.32,247.67,362.19Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.24,206.17a22.29,22.29,0,0,0,37.24,14.09l11.14,1.64-5.57-9.64a22.29,22.29,0,1,0-42.81-6.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,187.76a22.88,22.88,0,0,1,8.6-5.27,22.54,22.54,0,0,1,27.94,29.94l0-.39L112,221.7l.4.71-.8-.12-11.14-1.71.26-.08a22.5,22.5,0,0,1-11,5.44,18.83,18.83,0,0,1-3.09.32,21.26,21.26,0,0,1-3.09-.06,22,22,0,0,1-6-1.43,21.64,21.64,0,0,1-5.38-3,26.28,26.28,0,0,1-2.35-2,24.8,24.8,0,0,1-2-2.33,22.41,22.41,0,0,1,2.17-29.7Zm-2.1,29.65a19.87,19.87,0,0,0,4.38,4.27,21.13,21.13,0,0,0,5.37,2.9,21.15,21.15,0,0,0,9,1.31,19.29,19.29,0,0,0,3-.37A21.92,21.92,0,0,0,100.26,220l.11-.11.15,0,11.16,1.56-.4.59-5.61-9.62-.11-.18.09-.2a22.38,22.38,0,0,0,1.56-9.71,22,22,0,0,0-2.82-9.43,23,23,0,0,0-6.67-7.27,21.91,21.91,0,0,0-9.21-3.64,22.19,22.19,0,0,0-9.91.74A22.63,22.63,0,0,0,70,187.86a22,22,0,0,0-2.2,29.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.1 216.16 72.82 206.76 75.94 203.68 81.36 209.17 92.63 191.5 96.33 193.86 82.1 216.16",
    style: {
      fill: "#00796B"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.a82df9466d8c1326c02933564afb9800.svg";
export { ForwardRef as ReactComponent };